import React, { useState, useEffect } from "react";
import "./admincontrols.css";

const RoleManager = () => {
  const [mode, setMode] = useState(null);
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [config, setConfig] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    mail: "",
    password: "",
    role: "",
  });
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);

  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Error loading config:", err));
  }, []);

  // Fetch roles
  useEffect(() => {
    if (!config) return;

    fetch(`${config.BASE_URL}${config.GET_ROLES}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setRoles(data.roles);
      })
      .catch((err) => console.error("Error loading roles:", err));
  }, [config]);

  // Fetch all admin users (for update dropdown)
  useEffect(() => {
    if (!config) return;

    fetch(`${config.BASE_URL}${config.GET_ADMIN_USERS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setUsers(data.users);
      })
      .catch((err) => console.error("Error loading users:", err));
  }, [config]);

  // Handle form input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Send OTP
  const handleSendOtp = async () => {
    if (!formData.mail) {
      alert("Please enter an email first.");
      return;
    }

    try {
      const res = await fetch(`${config.BASE_URL}${config.ADMIN_SIGNUP_OTP}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
        email: formData.mail,
        name: formData.name
      }),
    });

      const data = await res.json();
      if (data.success) {
        setOtpSent(true);
        localStorage.setItem("otp", data.otp);
        alert("OTP sent successfully to your email.");
      } else {
        alert(data.message || "Failed to send OTP.");
      }
    } catch (err) {
      console.error("OTP error:", err);
      alert("Error sending OTP.");
    }
  };

  // Verify OTP
  const handleVerifyOtp = () => {
    const storedOtp = localStorage.getItem("otp");
    if (otp === storedOtp) {
      localStorage.setItem("otp_verified", "true");
      alert("OTP verified successfully!");
    } else {
      alert("Invalid OTP. Please try again.");
    }
  };

  // Save new user
  const handleSave = async () => {
    const verified = localStorage.getItem("otp_verified") === "true";
    if (!verified) {
      alert("Please verify your email OTP before saving.");
      return;
    }

    try {
      const res = await fetch(`${config.BASE_URL}${config.ADD_ADMIN_USER}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          name: formData.name,
          mobile: formData.mobile,
          mail: formData.mail,
          password: formData.password,
          role: formData.role,
          email_verified: true,
        }),
      });

      const data = await res.json();
      if (data.success) {
        alert("Admin user added successfully!");
        setFormData({
          name: "",
          mobile: "",
          mail: "",
          password: "",
          role: "",
        });
        localStorage.removeItem("otp_verified");
        localStorage.removeItem("otp");
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error("Save error:", err);
      alert("Error saving user.");
    }
  };

  // Fetch selected user details
  const handleSelectUser = async (id) => {
    setSelectedUser(id);

    try {
      const res = await fetch(`${config.BASE_URL}${config.GET_ADMIN_DETAILS}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ id }),
      });

      const data = await res.json();
      if (data.success) {
        setFormData({
          name: data.user.name,
          mobile: data.user.mobile,
          mail: data.user.mail,
          password: "", 
          role: data.user.role,
        });
      }
    } catch (err) {
      console.error("Error fetching user:", err);
    }
  };

  // Update user
  const handleUpdate = async () => {
    if (!selectedUser) {
      alert("Please select a user to update.");
      return;
    }

    try {
      const res = await fetch(`${config.BASE_URL}${config.UPDATE_ADMIN_USER}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          id: selectedUser,
          name: formData.name,
          mobile: formData.mobile,
          role: formData.role,
          password: formData.password || null, // only update if entered
        }),
      });

      const data = await res.json();
      if (data.success) {
        alert("User updated successfully!");
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error("Update error:", err);
      alert("Error updating user.");
    }
  };

  return (
    <div className="role-manager">
      <h2>Role Manager</h2>

      <div className="actions">
        <button onClick={() => setMode("add")}>Add</button>
        <button onClick={() => setMode("update")}>Update</button>
      </div>

      {/* ADD USER */}
      {mode === "add" && (
        <div className="form-container">
          <h3>Add User</h3>
          <label>Name:</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} />

          <label>Mobile:</label>
          <input type="text" name="mobile" value={formData.mobile} onChange={handleChange} />

          <label>Mail:</label>
          <input type="email" name="mail" value={formData.mail} onChange={handleChange} />
          <button type="button" onClick={handleSendOtp}>Send OTP</button>

          {otpSent && (
            <div className="otp-section">
              <input type="text" placeholder="Enter OTP" value={otp} onChange={(e) => setOtp(e.target.value)} />
              <button type="button" onClick={handleVerifyOtp}>Verify OTP</button>
            </div>
          )}

          <label>Password:</label>
          <input type="password" name="password" value={formData.password} onChange={handleChange} />

          <label>Role:</label>
          <select name="role" value={formData.role} onChange={handleChange}>
            <option value="">-- Select Role --</option>
            {roles.map((r) => (
              <option key={r.id} value={r.role}>{r.role}</option>
            ))}
          </select>

          <button onClick={handleSave}>Save</button>
        </div>
      )}

      {/* UPDATE USER */}
      {mode === "update" && (
        <div className="form-container">
          <h3>Update User</h3>

          <label>Select User:</label>
          <select value={selectedUser} onChange={(e) => handleSelectUser(e.target.value)}>
            <option value="">-- Select User --</option>
            {users.map((u) => (
              <option key={u.id} value={u.id}>{u.name}</option>
            ))}
          </select>

          {selectedUser && (
            <>
              <label>Name:</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} />

              <label>Mobile:</label>
              <input type="text" name="mobile" value={formData.mobile} onChange={handleChange} />

              <label>Mail (cannot change):</label>
              <input type="email" value={formData.mail} disabled />

              <label>Password (leave blank to keep same):</label>
              <input type="password" name="password" value={formData.password} onChange={handleChange} />

              <label>Role:</label>
              <select name="role" value={formData.role} onChange={handleChange}>
                <option value="">-- Select Role --</option>
                {roles.map((r) => (
                  <option key={r.id} value={r.role}>{r.role}</option>
                ))}
              </select>

              <button onClick={handleUpdate}>Update</button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default RoleManager;
